import React from 'react';
import { PapiUser } from '@wix/da-papi-types';
import UserGrid from '../../_partials/UserGrid';

export interface Visitor extends PapiUser {
  isLoggedin: boolean;
}

export interface Props {
  moduleId: number;
  seeAllUrl: string;
  browseUrl: string;
  username: string;
  visitor: Visitor;
  deviants: PapiUser[];
  isHeaderStickyOnMobile?: boolean;
}

export const WatchedDeviants: React.FC<Props> = ({ deviants }) => {
  return <UserGrid users={deviants} />;
};

export default WatchedDeviants;
